import React, { Component } from 'react';
import { connect } from 'react-redux';

class ScenarioHeader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    console.log(this.state);
    console.log(this.props.state.scenario);
    console.log(this.props.state.scenario.selectedScenario);
    const { data } = this.state;
    return (
      <div className="scenarioHeader">
        {this.props.state.scenario.selectedScenario && (
          <div
            style={{
              backgroundColor: 'red',
              padding: '1em',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '16px',
              textAlign: 'center'
            }}
          >
            SCENARIO MODE - CURRENT SCENARIO IS:{' '}
            {this.props.state.scenario.selectedScenario}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  console.log(state);
  return {
    state
  };
}

const connectedScenarioHeader = connect(mapStateToProps)(ScenarioHeader);
export { connectedScenarioHeader as ScenarioHeader };



// WEBPACK FOOTER //
// ./src/Components/ScenarioHeader.js